export default {
  init() {
    // JavaScript to be fired on all pages

    var $hamburger = $('.hamburger');
    $hamburger.on('click', function() {
      $hamburger.toggleClass('is-active');
      // Do something else, like open/close menu
      $('body').toggleClass('menu-open');
    });

    //close mobile menu if clicking on jump menu
    $('a[href=\'#newsletter-block\']').on('click', function(){
      $( 'button.navbar-toggler.is-active' ).trigger( 'click' );
    });


    $('body').on('click', 'a[href*=\'#\']:not([href=\'#\'],[data-slide=\'prev\'],[data-slide=\'next\'],[data-toggle=\'collapse\'],[data-toggle=\'tab\'],[href=\'#tab\'])', function(e) {
        $('html, body').animate({scrollTop: $( $.attr(this, 'href') ).offset().top - 75}, 500);
        e.preventDefault();
    });

  },

  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    //

    var $hamburger = $('.hamburger');

    $hamburger.on('click', function(){
      $('.header_cont').toggleClass('menu-is-open');
    });

    // Show/hide search dropdown
    $('#toggleSearch').on('click', function(){
      $('header,body').toggleClass('search-open');
    });

    $('.search-toggle').on('click', function() {
      $('header,body').toggleClass('search-open');
    });


    // Hide search when click off
    $(document).mouseup(function(e){
       var menu = $('header.search-open');
       if (!menu.is(e.target) // The target of the click isn't the container.
       && (menu.has(e.target).length === 0) // Nor a child element of the container
      )
       {
          $('header,body').removeClass('search-open');
       }
    });

    // Hide search dropdown
    $('#closeSearch').on('click', function(){
      $('header,body').removeClass('search-open');
    });

    // Hide search when click off
    $(document).mouseup(function(e){
       var menu = $('#searchDropdown');
       if (!menu.is(e.target) // The target of the click isn't the container.
       && menu.has(e.target).length === 0) // Nor a child element of the container
       {
          $('header,body').removeClass('search-open');
       }
    });

    // Show hidden search when tapping 'enter' key
    $('#toggleSearch, #closeSearch').keypress(function (e) {
      var key = e.which;
      if(key == 13)  // the enter key code
      {
        $('header,body').toggleClass('search-open');
        return false;
      }
    });



    var $backToTop = $('#backtotop');

    $(window).on('scroll', function() {
      if (window.scrollY > 50) {
        $backToTop.addClass('active');
        $('.header_cont').addClass('scrolled');
      } else {
        $backToTop.removeClass('active');
        $('.header_cont').removeClass('scrolled');
      }
    });


    $backToTop.on('click', function(e) {

        $('html, body').animate({scrollTop:0}, 500);
        e.preventDefault();

    });




    function isInViewport(node) {
      // Am I visible? Height and Width are not explicitly necessary in visibility
      // detection, the bottom, right, top and left are the essential checks. If an
      // image is 0x0, it is technically not visible, so it should not be marked as
      // such. That is why either width or height have to be > 0.
      var rect = node.getBoundingClientRect()
      return (
        (rect.height > 0 || rect.width > 0) &&
        rect.bottom >= 0 &&
        rect.right >= 0 &&
        rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.left <= (window.innerWidth || document.documentElement.clientWidth)
      )
    }

    var width = $(window).width();
    $(window).resize(function() {
      width = $(window).width();
    });

    $(window).on('scroll', function () {
      if (width >= 992){
        var scrolled = $(document).scrollTop();

        $('.parallax-background').each(function() {
          var initY = $(this).offset().top
          var height = $(this).height()
          //var endY = initY + $(this).height()
          // Check if the element is in the viewport.
          var visible = isInViewport(this)
          if(visible) {
            var diff = scrolled - initY
            var ratio = (diff / height) * 100
            $(this).css('background-position','center CALC(50% + ' + Math.floor((ratio * 3)) + 'px)')
          }
        })

        $('.parallax-carousel').each(function() {
          var initY = $(this).offset().top
          var height = $(this).height()
          //var endY = initY + $(this).height()
          // Check if the element is in the viewport.
          var visible = isInViewport(this)
          if(visible) {
            var diff = scrolled - initY
            var ratio = (diff / height) * 100
            $(this).find('.carousel-item').css('background-position','center CALC(50% + ' + Math.floor((ratio * 3)) + 'px)')
          }
        })
      }
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js